import styled from "styled-components";

export const StyledMakeAppointmentStep = styled.p`
  display: flex;
  align-items: center;
  color: #A1ABC9;
  margin-bottom: 40px;
  width: 100%;
  margin-top: 40px;

  & span {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #A1ABC9;
    border-radius: 50%;
    height: 32px;
    width: 32px;
    margin-right: 16px;
    padding: 16px;
  }
`
